import { render } from "./Create.vue?vue&type=template&id=b0bb5ff0&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"timezone\":\"props\",\"form\":\"data\",\"create\":\"options\"}"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "b0bb5ff0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0bb5ff0')) {
    api.reload('b0bb5ff0', script)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=b0bb5ff0&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"timezone\":\"props\",\"form\":\"data\",\"create\":\"options\"}", () => {
    api.rerender('b0bb5ff0', render)
  })

}

script.__file = "resources/js/Pages/Classrooms/Sessions/Create.vue"

export default script